module.exports = __webpack_public_path__ + "img/glass.7a62c196.svg";